"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgClose(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M1.222.15l.086.074 10.691 10.692L22.691.224a.766.766 0 011.158.998l-.074.086-10.693 10.691 10.694 10.693a.766.766 0 01-.998 1.158l-.086-.074L12 13.082 1.308 23.776a.766.766 0 01-1.158-.998l.074-.086L10.916 12 .224 1.308A.766.766 0 011.222.15z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgClose;
exports.default = _default;